import { useState } from "react";
import { usersData } from "../../Data/Data";
import RowUsers from "./SubUsers/RowUsers";
import HeaderUsers from "./SubUsers/HeaderUsers";
import TitleTable from "./SubUsers/TitleTable";
import NotFound from "../../msg/NotFound";
import SuccessMsg from "../UserManagment/SubUserManagment/SuccessMsg";
import ErrorMsg from "../UserManagment/SubUserManagment/ErrorMsg";
import CreateUser from "./SubUsers/CreateUser";


function Users() {

    const [openAddUser, setOpenAddUser] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [openSuccess, setOpenSuccess] = useState("");
    const [openError, setOpenError] = useState("");

    const handleUserAdded = (newUser) => {

    };

    const handleSelectUser = (id, checked) => {
        setSelectedUsers((prev) =>
            checked ? [...prev, id] : prev.filter((uid) => uid !== id)
        )
    }

    return (
        <>
            <div className="m-10">

                <HeaderUsers
                    selectedUsers={selectedUsers}
                    users={usersData}
                    setSelectedUsers={setSelectedUsers}
                    setOpenAddUser={setOpenAddUser}
                    openError={setOpenError}
                    openSuccess={setOpenSuccess}
                />

                {usersData.length === 0 ? (
                    <NotFound text="متاسفانه کاربری یافت نشد" />
                ) : (
                    <>
                        <TitleTable />
                        {usersData.map((item, index) => {
                            return (
                                <RowUsers
                                    key={item.id}
                                    item={item}
                                    index={index}
                                    onSelect={handleSelectUser}
                                    isSelected={selectedUsers}
                                />
                            )
                        })}
                    </>
                )}
            </div>

            {openAddUser && (
                <CreateUser
                    close={setOpenAddUser}
                    onUserAdded={handleUserAdded}
                    openError={setOpenError}
                    openSuccess={setOpenSuccess}
                />
            )}

            {openSuccess && <SuccessMsg close={setOpenSuccess} msg={openSuccess} />}

            {(openError) && (
                <ErrorMsg close={setOpenError} msg={openError} />
            )}
        </>
    );
}
export default Users;